import {
  Pagination,
  PaginationContainer, PaginationNext, PaginationPage,
  PaginationPageGroup,
  PaginationPrevious,
  PaginationSeparator, usePagination
} from "@ajna/pagination";
import { Center } from "@chakra-ui/react";

function Paginator({ selectedPage, numberOfPages, handlePageSelection }) {
  const {
    setCurrentPage,
    pagesCount,
    pages
  } = usePagination({
    pagesCount: numberOfPages,
    limits: {
      outer: 1,
      inner: 1
    },
    initialState: { currentPage: 1 }
  });

  const handlePageChange = (nextPage) => {
    setCurrentPage(nextPage);
    handlePageSelection(nextPage);
  };

  return (
    <Center>
      <Pagination
        pagesCount={pagesCount}
        currentPage={selectedPage}
        onPageChange={handlePageChange}
      >
        <PaginationContainer>
          <PaginationPrevious
            w={25}
            marginRight={2}
            border="1px solid #EAEDF3"
          >
            {"<"}
          </PaginationPrevious>
          <PaginationPageGroup
            separator={
              <PaginationSeparator
                w={25}
                jumpSize={10}
                borderRadius="sm"
              />
            }
          >
            {pages.map(page => (
              <PaginationPage
                key={`pagination_page_${page}`}
                page={page}
                _focus={{ boxShadow: "none" }}
                _hover={{ bg: "var(--chakra-colors-esg_sub_active);" }}
                _current={{ bg: "var(--chakra-colors-esg_active);", color: "black" }}
                w={34}
                fontWeight="normal"
                margin={"0 2px"}
                border="1px solid #EAEDF3"
                borderRadius="sm"
              />
            ))}
          </PaginationPageGroup>
          <PaginationNext marginLeft={2} border="1px solid #EAEDF3" borderRadius="sm">{">"}</PaginationNext>
        </PaginationContainer>
      </Pagination>
    </Center>
  );
}

export default Paginator;